export default class Setting {
    constructor(key, defaultValue, description) {
        this.key = key;
        this.value = defaultValue;
        this.description = description;
    }
    toggle() {
        this.value = !this.value;
    }
}